export const FETCH_SECTIONS_GROUP_API = '/section/group/:id';
